module.exports = __webpack_public_path__ + "img/24_fineStaff_phc.d4df72bb.png";